import Base from './_base'
import request from './request'
import {
  API_ROUTES_CHECK_DOCUMENTS,
  API_ROUTES_GET_VEHICLE_MODELS,
  API_ROUTES_GET_CITIES,
  API_ROUTES_CHECK_AGENT,
  API_ROUTES_CHECK_BSO,
  API_ROUTES_GET_OFFICES,
  API_ROUTES_GET_OFFICES_BY_BOUNDS,
  API_ROUTES_CHECK_STATUS,
  API_ROUTES_GET_STOAS,
  API_ROUTES_GET_REGIONS,
  API_ROUTES_REGISTER_CLAIM,
  API_ROUTES_SEND_CONFIRM_EMAIL_APPEAL,
  API_ROUTES_SEND_DEBTOR,
  API_ROUTES_SEND_APPEAL,
  API_ROUTES_GET_APPEAL,
  API_ROUTES_SEND_SMS,
  API_ROUTES_SEND_SPORT_INSURANCE_CASE,
  API_ROUTES_GET_INSURANCE_PERIODS,
  API_ROUTES_FEEDBACK_AGENTS,
  API_SEARCH_BOT_SEARCHING,
  API_SEARCH_NEXT_QUESTION,
  API_SEARCH_BOT_AUTOCOMPLETE,
  GET_PHONE_VERIFICATION_CODE,
  SEND_PHONE_VERIFICATION_CODE,
  GET_FEEDBACK_SELECT_LISTS,
  API_ROUTES_SEND_FEEDBACK,
  API_ROUTES_SEND_FOREIGN,
  API_ROUTES_SHIP_POLICY_SEARCH,
  API_ROUTES_GET_AGENTS_BY_BOUNDS,
  API_ROUTES_SEND_TO_AGENT,
  API_ROUTES_APPEAL_LOG_APPLICATION,
  API_GET_EMAIL_VERIFICATION_CODE,
  API_SEND_EMAIL_VERIFICATION_CODE,
  API_LOG_MARKETING_AGREEMENT,
  API_ROUTES_CHECK_RESOLUTE_GOS_NUM,
  API_ROUTES_BECOME_AGENT,
  API_ROUTES_GET_CLINICS_BY_BOUNDS,
  API_ROUTES_SEND_CERTIFICATE_PAYMENT,
  API_ROUTES_KASKO_SEARCH,
  API_ROUTES_KASKO_PAYMENT_CREATE,
  API_ROUTES_KASKO_PAYMENT_STATUS,
  API_ROUTES_KASKO_EMAIL_UPDATE,
  API_ROUTES_KASKO_DOCUMENTS,
  API_ROUTES_SEND_MORTGAGE_APPEAL,
  API_SEARCH_BOT_START,
  API_SEARCH_BOT_RESTART,
  API_SEARCH_BOT_EVENT,
  API_SEARCH_BOT_SEND,
  API_SEARCH_BOT_GET,
  API_SEARCH_BOT_RATE,
  API_ROUTES_SERVICE_FORM,
  API_ROUTES_GRAPHQL,
  API_ROUTES_SEND_CAREER_FORM,
  API_ROUTES_SPRUT_PRODUCTS,
  API_ROUTES_SPRUT_CALCULATE,
  API_ROUTES_SPRUT_CONTRACT_INIT,
  API_ACTIVATE_CERTIFICATE_WB,
  API_ROUTES_SEND_MC_ORM_EVENT,
  API_SEND_APPEAL_BUY_BY_TEL_REGION,
} from '@/config/constants'
import { QueryRegionRequest } from '@/contracts/api/QueryRegion/QueryRegion.Request'
import { QueryRegionResponse } from '@/contracts/api/QueryRegion/QueryRegion.Response'
import { ApiReturn } from '@/contracts/api/RequestReturn'
import { QueryCitiesRequest } from '@/contracts/api/QueryCites/QueryCities.Request'
import { QueryCitiesResponse } from '@/contracts/api/QueryCites/QueryCities.Response'
import { QueryOfficesResponse } from '@/contracts/api/QueryOffices/QueryOffices.Response'
import { QueryOfficeRequest } from '@/contracts/api/QueryOffices/QueryOffice.Request'
import { RegisterClaimResponse } from '@/contracts/api/RegisterClaim/RegisterClaimResponse'
import { BackendModel } from '@/contracts/AppealModel'
import { RegisterClaimRequest } from '@/contracts/api/RegisterClaim/RegisterClaim.Request'
import { QueryInstancePeriodResponse } from '@/contracts/api/QueryInsuracePeriods/QueryInsurancePeriod.Response'
import { FeedbackAgentsPayload } from '@/contracts/FeedbackAgents'
import {
  SearchBotAutocompleteResponse,
  SearchBotDataResponse,
  SearchBotQuestion,
  SearchBotQuestionResponse,
} from '@/contracts/api/QuerySearchBot/QuerySearchBot.Response'
import { SelectListResponse } from '@/contracts/api/QueryFeedback/QueryFeedback.response'
import { BecomeAgentRequest } from '@/contracts/api/BecomeAgent/BecomeAgent.Request'
import {
  ProlongationKaskoData,
  ProlongationPaymentResponse,
} from '@/contracts/Prolongation'
import { SprutCalculateProductRequest } from '@/contracts/api/Sprut/SprutCalculateProduct.Request'
import { SprutInitContractRequest } from '@/contracts/api/Sprut/SprutInitContract.Request'
import { SprutProductsResponse } from '@/contracts/api/Sprut/SprutProducts.Response'
import { SendFormActivateCertificateWbRequest } from '@/contracts/api/CertificateWb/SendFormActivateCertificateWb.Request'

export default class Auto extends Base {
  /**
   * Получение списка регионов
   * @param {?QueryRegionRequest} requestPayload
   * @return ApiReturn<QueryRegionResponse>
   */
  async getRegions(requestPayload: QueryRegionRequest = {}) {
    const defaultPayload: QueryCitiesRequest = {
      page: 1,
    }

    const params = {
      ...defaultPayload,
      ...requestPayload,
    }

    return {
      data: await request<QueryRegionResponse>(
        this.$ctx,
        'get',
        API_ROUTES_GET_REGIONS,
        params
      ),
    }
  }

  // ЗАПРОС СПИСКА ГОРОДОВ В ВЫБРАННОМ РЕГИОНЕ
  async getCities(requestPayload: QueryCitiesRequest = {}) {
    const defaultPayload: QueryCitiesRequest = {
      page: 1,
    }

    const params = {
      ...defaultPayload,
      ...requestPayload,
    }

    return {
      data: await request<QueryCitiesResponse>(
        this.$ctx,
        'get',
        API_ROUTES_GET_CITIES,
        params
      ),
    }
  }

  // ЗАПРОС СПИСКА ОФИСОВ ПО ГОРОДАМ РЕГИОНА
  async getOffices(requestPayload: QueryOfficeRequest) {
    const defaultPayload: QueryCitiesRequest = {
      page: 1,
    }

    const params = {
      ...defaultPayload,
      ...requestPayload,
    }

    return {
      data: await request<QueryOfficesResponse>(
        this.$ctx,
        'get',
        API_ROUTES_GET_OFFICES,
        params
      ),
    }
  }

  async getSearchBotData(text: string) {
    return await request<SearchBotQuestion[]>(
      this.$ctx,
      'get',
      API_SEARCH_BOT_SEARCHING,
      { text }
    )
  }

  async startSearchBotSession(context: any) {
    return await request(this.$ctx, 'post', API_SEARCH_BOT_START, { context })
  }

  async restartSearchBotSession(dialogUID: string, context: any) {
    return await request(this.$ctx, 'post', API_SEARCH_BOT_RESTART, {
      dialogUID,
      context,
    })
  }

  async sendSearchBotEvent(dialogUID: string, eventId: string, context: any) {
    return await request(this.$ctx, 'post', API_SEARCH_BOT_EVENT, {
      dialogUID,
      eventId,
      context,
    })
  }

  async sendSearchBotRequest(dialogUID: string, message: string, context: any) {
    return await request(this.$ctx, 'post', API_SEARCH_BOT_SEND, {
      dialogUID,
      message,
      context,
    })
  }

  async getSearchBotResponse(reqid: string) {
    return await request(this.$ctx, 'get', API_SEARCH_BOT_GET, {
      reqid,
    })
  }

  async rateSearchBot(
    dialogUID: string,
    reqid: string,
    rate: number,
    context: any
  ) {
    return await request(this.$ctx, 'post', API_SEARCH_BOT_RATE, {
      dialogUID,
      reqid,
      rate,
      context,
    })
  }

  async getShipPolicy(text: string) {
    return await request(this.$ctx, 'get', API_ROUTES_SHIP_POLICY_SEARCH, {
      text,
    })
  }

  async getSearchBotAutocomplete(text: string) {
    return await request<[]>(this.$ctx, 'get', API_SEARCH_BOT_AUTOCOMPLETE, {
      text,
    })
  }

  async getSearchBotNextQuestion(questionId: number) {
    return await request<SearchBotQuestionResponse>(
      this.$ctx,
      'get',
      API_SEARCH_NEXT_QUESTION + `${questionId}`,
      {}
    )
  }

  // ЗАПРОС СПИСКА ОФИСОВ ПО ОБЛАСТИ ВИДИМОСТИ КАРТЫ
  async getOfficesByBounds(params: any) {
    return {
      data: await request(
        this.$ctx,
        'get',
        API_ROUTES_GET_OFFICES_BY_BOUNDS,
        params,
        {}
      ),
    }
  }

  // ЗАПРОС СПИСКА КЛИНИК ПО ОБЛАСТИ ВИДИМОСТИ КАРТЫ
  async getClinicsByBounds(params: any) {
    return {
      data: await request(
        this.$ctx,
        'get',
        API_ROUTES_GET_CLINICS_BY_BOUNDS,
        params,
        {}
      ),
    }
  }

  async getAgentsByBounds(params: any) {
    return {
      data: await request(
        this.$ctx,
        'get',
        API_ROUTES_GET_AGENTS_BY_BOUNDS,
        params,
        {}
      ),
    }
  }

  async getVehicleModels(search: string): Promise<any> {
    const params = {
      name: search,
    }
    return {
      data: await request(
        this.$ctx,
        'get',
        API_ROUTES_GET_VEHICLE_MODELS,
        params
      ),
    }
  }

  async checkDocuments(params: { email: string }): Promise<any> {
    return {
      data: await request(
        this.$ctx,
        'post',
        API_ROUTES_CHECK_DOCUMENTS,
        params
      ),
    }
  }

  async checkAgent(params: {
    name: string
    inn: string
    url: string
    docNumber: string
    isNew?: boolean
  }): Promise<any> {
    // Удаляем пустые поля из параметров
    Object.keys(params).forEach(
      (k) =>
        params[k as keyof Object] === null && delete params[k as keyof Object]
    )

    return {
      data: await request(this.$ctx, 'post', API_ROUTES_CHECK_AGENT, params),
    }
  }

  async checkStatus(params: {
    lastName: string
    number: number
  }): Promise<any> {
    return {
      data: await request(this.$ctx, 'post', API_ROUTES_CHECK_STATUS, params),
    }
  }

  async getFeedbackSelectLists(): Promise<SelectListResponse> {
    return await request(this.$ctx, 'get', GET_FEEDBACK_SELECT_LISTS)
  }

  async getVerificationCode(params: {
    fingerPrint: string
    phone: string
    clientIp: string
  }): Promise<{ data: { success: boolean }; errors: { message: string }[] }> {
    return await request(this.$ctx, 'post', GET_PHONE_VERIFICATION_CODE, params)
  }

  async postVerificationCode(params: {
    code: string
    phone: string
    clientIp: string
  }): Promise<{ data: { success: boolean }; errors: { message: string }[] }> {
    return await request(
      this.$ctx,
      'post',
      SEND_PHONE_VERIFICATION_CODE,
      params
    )
  }

  async getEmailVerificationCode(params: {
    fingerPrint: string
    email: string
    clientIp: string
    message: string
  }): Promise<{ data: { success: boolean }; errors: { message: string }[] }> {
    return await request(
      this.$ctx,
      'post',
      API_GET_EMAIL_VERIFICATION_CODE,
      params
    )
  }

  async postEmailVerificationCode(params: {
    code: string
    email: string
    clientIp: string
  }): Promise<{ data: { success: boolean }; errors: { message: string }[] }> {
    return await request(
      this.$ctx,
      'post',
      API_SEND_EMAIL_VERIFICATION_CODE,
      params
    )
  }

  async logMarketingAgreement(params: {
    email: string
    agreement: string
    clientIp: string
  }): Promise<{ data: { success: boolean }; errors: { message: string }[] }> {
    return await request(this.$ctx, 'post', API_LOG_MARKETING_AGREEMENT, params)
  }

  async checkBso(params: { series: string; number: string }): Promise<any> {
    return {
      data: await request(this.$ctx, 'post', API_ROUTES_CHECK_BSO, params),
    }
  }

  async feedbackAgents(params: FeedbackAgentsPayload) {
    return await request(this.$ctx, 'post', API_ROUTES_FEEDBACK_AGENTS, params)
  }

  // ОТПРАВКА УВЕДОМЛЕНИЙ ПО СТРАХОВОМУ СЛУЧАЮ КАСКО ИЛИ ОСАГО
  async registerClaim(params: RegisterClaimRequest) {
    return {
      data: await request<RegisterClaimResponse>(
        this.$ctx,
        'post',
        API_ROUTES_REGISTER_CLAIM,
        params
      ),
    }
  }

  // ЗАПРОС СПИСКА СТОА
  async getStoas(
    page: number,
    perPage: number,
    city: string,
    sort: string
  ): Promise<any> {
    const params = {
      page,
      perPage,
      city,
      sort,
    }

    return {
      data: await request(this.$ctx, 'get', API_ROUTES_GET_STOAS, params),
    }
  }

  async getInsurancePeriodInfo(year: number): Promise<{
    data: QueryInstancePeriodResponse
  }> {
    return {
      data: await request<QueryInstancePeriodResponse>(
        this.$ctx,
        'get',
        API_ROUTES_GET_INSURANCE_PERIODS,
        {
          year,
        }
      ),
    }
  }

  // ЗАПРОС СПИСКА СТОА
  async getAppeal(GUID: string): Promise<any> {
    return {
      data: await request(this.$ctx, 'get', API_ROUTES_GET_APPEAL, { GUID }),
    }
  }

  // ЗАПРОС СПИСКА СТОА
  async sendEmailConfirmAppeal(email: string): Promise<any> {
    const params = {
      email,
    }
    return {
      data: await request(
        this.$ctx,
        'post',
        API_ROUTES_SEND_CONFIRM_EMAIL_APPEAL,
        params
      ),
    }
  }

  // ЗАПРОС СПИСКА СТОА
  async sendAppeal(model: BackendModel): Promise<any> {
    return {
      data: await request(this.$ctx, 'post', API_ROUTES_SEND_APPEAL, model),
    }
  }

  async sendMortgageAppeal(model: BackendModel): Promise<any> {
    return {
      data: await request(
        this.$ctx,
        'post',
        API_ROUTES_SEND_MORTGAGE_APPEAL,
        model
      ),
    }
  }

  async sendMcOrmEvent(model: FormData): Promise<any> {
    return {
      data: await request(
        this.$ctx,
        'post',
        API_ROUTES_SEND_MC_ORM_EVENT,
        model
      ),
    }
  }

  async becomeAgent(req: BecomeAgentRequest): Promise<any> {
    return {
      data: await request(this.$ctx, 'post', API_ROUTES_BECOME_AGENT, req),
    }
  }

  async sendAppealBuyByTelRegion(req: {
    emailInfo: {
      title: string
      elementId: number
      propertyId: number
      description: string
    }
    formType: string
  }): Promise<any> {
    return {
      data: await request(
        this.$ctx,
        'post',
        API_SEND_APPEAL_BUY_BY_TEL_REGION,
        req
      ),
    }
  }

  async sendCareerForm(model: FormData) {
    return {
      data: await request(
        this.$ctx,
        'post',
        API_ROUTES_SEND_CAREER_FORM,
        model
      ),
    }
  }

  async sendAppealLogApplication(model: BackendModel): Promise<any> {
    return {
      data: await request(
        this.$ctx,
        'post',
        API_ROUTES_APPEAL_LOG_APPLICATION,
        model
      ),
    }
  }

  async checkResolutGosNumber(gosNumber: string): Promise<any> {
    return {
      data: await request(
        this.$ctx,
        'post',
        API_ROUTES_CHECK_RESOLUTE_GOS_NUM,
        { gosNumber }
      ),
    }
  }

  async sendCertificatePaymentForm(model: FormData): Promise<any> {
    return {
      data: await request(
        this.$ctx,
        'post',
        API_ROUTES_SEND_CERTIFICATE_PAYMENT,
        model
      ),
    }
  }

  async sendFeedbackForm(model: FormData): Promise<any> {
    return {
      data: await request(this.$ctx, 'post', API_ROUTES_SEND_FEEDBACK, model),
    }
  }

  async sendForeignForm(model: Record<string, unknown>): Promise<any> {
    return {
      data: await request(this.$ctx, 'post', API_ROUTES_SEND_FOREIGN, model),
    }
  }

  async sendInsuranceCaseForm(model: FormData): Promise<any> {
    return {
      data: await request(
        this.$ctx,
        'post',
        API_ROUTES_SEND_SPORT_INSURANCE_CASE,
        model
      ),
    }
  }

  // Отправка обращения должников
  async sendDebtor(params: FormData): Promise<any> {
    return {
      data: await request(this.$ctx, 'post', API_ROUTES_SEND_DEBTOR, params),
    }
  }

  // Отправка обращения должников
  async sendSms(
    name: string,
    phone: string,
    agentPhone: string,
    time: string /* token: string */
  ): Promise<any> {
    return {
      data: await request(this.$ctx, 'post', API_ROUTES_SEND_SMS, {
        name,
        phone,
        agentPhone,
        time,
        // token
      }),
    }
  }

  // Отправка письма агенту
  async sendEmailToAgent(params: FormData): Promise<any> {
    return {
      data: await request(this.$ctx, 'post', API_ROUTES_SEND_TO_AGENT, params),
    }
  }

  // ЗАПРОС ПОЛИСА КАСКО ПО НОМЕРУ
  async getKaskoByNumber(payload: {
    contractSeriesNumber: string
  }): Promise<{ data: ProlongationKaskoData }> {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    return {
      data: await request(this.$ctx, 'post', API_ROUTES_KASKO_SEARCH, {
        contractSeriesNumber: payload.contractSeriesNumber,
        timeZone,
      }),
    }
  }

  async getKaskoPayment(payload: {
    submissionId: string
    paymentMethodId: '5' | '12'
    returnUrl: {
      success: string
      fail: string
    }
  }): Promise<{ data: ProlongationPaymentResponse }> {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    return {
      data: await request(this.$ctx, 'post', API_ROUTES_KASKO_PAYMENT_CREATE, {
        submissionId: payload.submissionId,
        paymentMethodId: payload.paymentMethodId,
        returnUrl: payload.returnUrl,
        timeZone,
      }),
    }
  }

  async getKaskoPaymentStatus(payload: { contractId: string }): Promise<any> {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    return {
      data: await request(this.$ctx, 'post', API_ROUTES_KASKO_PAYMENT_STATUS, {
        contractId: payload.contractId,
        timeZone,
      }),
    }
  }

  async getKaskoDocuments(payload: { submissionId: string }): Promise<any> {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    return {
      data: await request(this.$ctx, 'get', API_ROUTES_KASKO_DOCUMENTS, {
        submissionId: payload.submissionId,
        timeZone,
      }),
    }
  }

  async updateKaskoEmail(payload: {
    submissionId: string
    email: string
  }): Promise<any> {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    return {
      data: await request(this.$ctx, 'patch', API_ROUTES_KASKO_EMAIL_UPDATE, {
        submissionId: payload.submissionId,
        email: payload.email,
        timeZone,
      }),
    }
  }

  async sendServiceForm(params: any): Promise<any> {
    return await request(this.$ctx, 'post', API_ROUTES_SERVICE_FORM, params)
  }

  async sendGraphqlQuery(params: {
    operationName?: string
    variables?: unknown
    query: string
  }): Promise<any> {
    return await request(this.$ctx, 'post', API_ROUTES_GRAPHQL, params)
  }

  async getSprutProducts(): Promise<SprutProductsResponse> {
    return await request(this.$ctx, 'get', API_ROUTES_SPRUT_PRODUCTS)
  }

  async calculateSprutProduct(
    params: SprutCalculateProductRequest
  ): Promise<any> {
    return await request(this.$ctx, 'post', API_ROUTES_SPRUT_CALCULATE, params)
  }

  async initSprutContract(params: SprutInitContractRequest): Promise<any> {
    return await request(
      this.$ctx,
      'post',
      API_ROUTES_SPRUT_CONTRACT_INIT,
      params
    )
  }

  async sendFormActivateCertificateWb(
    params: SendFormActivateCertificateWbRequest
  ): Promise<any> {
    return await request(this.$ctx, 'post', API_ACTIVATE_CERTIFICATE_WB, params)
  }
}
